import React,{ Component } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import Cookies from 'js-cookie';
import axios from 'axios';
class NavBar extends Component {
    constructor (props){
      super(props);
      this.state = {
          username:""

      }
    }

    componentDidMount() {
      this.handleQueryString();
    }
    handleQueryString = () => {
      let queries = queryString.parse(window.location.search);
      if(queries.username !=undefined)
      {
        const options = {
          headers: {"content-type": "text/plain"}
      }
      axios.post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/PostUsername', {
      username: queries.username
      },options)
      .then(res=> {            
        this.setState ( { username: res.data} );
        console.log(res);
        if(this.state.username == "abc" || this.state.username == "")
        {
          window.location.href = 'https://as-mobilization-stage.accenture.com/Nest-Home.aspx';
        }
          })
          .catch(err => {
            console.log(err);
        }) 
        
        
      } 
     
    
    }
    Logout() {
      localStorage.clear();
      sessionStorage.clear();
     
     
     
       window.location.href = 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb/oauth2/v2.0/logout?post_logout_redirect_uri=https%3A%2F%2Fas-mobilization.accenture.com&x-client-SKU=ID_NET45&x-client-ver=5.3.0.0';
    }
    render() {
      return (
        <div>
        <div class="home_banner">
  
        <header class="container-fluid container-header col-md-12 padding-right0">
                  <div>
                      <div class="col-md-12" >
            
      <div class="logo" >
                              <a href="https://as-mobilization-stage.accenture.com/">
                                  <img src="images/new-logo.png" style={{marginTop:10,marginLeft:-12}} alt="Accenture Technology" class="img-responsive"></img></a>
            
              </div>
                          
                    
                           <div style={{float:'Right'}}>
                           
                           <div class="header-right-style" style={{marginBottom:-8,marginTop:3}}>AMS -IMS Startup</div>
                              <img src="images/Profile.png" alt="" style={{display:'Inline',marginTop:10,marginRight:5,marginBottom:10}} class="img-responsive" />
                             <label ID="lblUsername"  class="user-style" aria-hidden="true" style={{display:'Inline'}} >{this.state.username}</label>
                             <a href="https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb/oauth2/v2.0/logout?post_logout_redirect_uri=https%3A%2F%2Fas-mobilization.accenture.com&x-client-SKU=ID_NET45&x-client-ver=5.3.0.0">
                             <img src="images/logout.png" style={{marginBottom:10}} onClick={this.Logout} alt="" />     </a>          
                          </div>
  
                        
            
                      
                  </div>
            </div>
               </header>
              
  </div>
  <label></label>
  
      </div>
        
      );
    };
    }
    
    export default NavBar;